export default "__VITE_ASSET__C2Qob4Zf__"